// CBR Controle-Vragen (Voertuigcontrole examen)
// image + highlight (x/y/r in % van de foto) tonen een omcirkeld onderdeel.
const DASH_IMG = "/cbr/dash.webp";
const LIGHT_IMG = "/cbr/licht.webp";

const CBR_QUESTIONS = [
  // ═══════════════════════ BANDEN (8 — meest gevraagd) ═══════════════════════
  {
    id: 10, category: "Banden",
    question: "Wat is de wettelijke minimale profieldiepte van een personenauto-band?",
    answers: [
      { text: "1,6 mm", correct: true },
      { text: "3,0 mm", correct: false },
      { text: "1,0 mm", correct: false },
    ],
    explanation: "Onder 1,6 mm is de band wettelijk afgekeurd. Advies bij winter: minimaal 4 mm."
  },
  {
    id: 11, category: "Banden",
    question: "Waar vind je de juiste bandenspanning voor jouw auto?",
    answers: [
      { text: "Op de sticker in de deurstijl, tankklep of in het instructieboekje", correct: true },
      { text: "Op de zijkant van de band zelf", correct: false },
      { text: "Bij elk tankstation hangt een tabel", correct: false },
    ],
    explanation: "De zijkant van de band toont alleen de MAX druk, niet de aanbevolen druk voor jouw auto."
  },
  {
    id: 12, category: "Banden",
    question: "Wanneer meet je bandenspanning het beste?",
    answers: [
      { text: "Bij koude banden (na max. 2 km rijden)", correct: true },
      { text: "Direct na een lange snelwegrit — dan is de meting het meest nauwkeurig", correct: false },
      { text: "Maakt niet uit wanneer", correct: false },
    ],
    explanation: "Warme banden geven een hogere (foute) meetwaarde. Koud = correct."
  },
  {
    id: 13, category: "Banden",
    question: "Wat is het gevolg van te lage bandenspanning?",
    answers: [
      { text: "Meer slijtage, slechter sturen, hoger brandstofverbruik en risico op klapband", correct: true },
      { text: "Betere grip omdat de band zich aanpast aan de weg", correct: false },
      { text: "Geen effect zolang de band nog vol lucht heeft", correct: false },
    ],
    explanation: "Te lage spanning is gevaarlijk én duur — check hem elke 2 tot 4 weken."
  },
  {
    id: 14, category: "Banden",
    question: "Hoe controleer je snel het profiel op de band?",
    answers: [
      { text: "Met een profieldieptemeter of met een muntstuk in de groef", correct: true },
      { text: "Met een schroevendraaier tussen de tanden", correct: false },
      { text: "Alleen op gevoel — als hij glad voelt is hij op", correct: false },
    ],
    explanation: "Slijtage-indicatoren (kleine bultjes in de groef) laten zien wanneer de band vervangen moet."
  },
  {
    id: 15, category: "Banden",
    question: "Waar let je nog meer op naast profiel en spanning?",
    answers: [
      { text: "Scheuren, uitstulpingen, glasscherven of ongelijke slijtage", correct: true },
      { text: "Alleen op de kleur van het rubber", correct: false },
      { text: "Alleen op de merknaam op de zijkant", correct: false },
    ],
    explanation: "Een uitstulping (bult) is levensgevaarlijk — direct laten vervangen."
  },
  {
    id: 16, category: "Banden",
    question: "Wat betekent de code '205/55 R16 91V' op de band?",
    answers: [
      { text: "205 = breedte in mm, 55 = hoogte-%, R16 = velgmaat, 91V = belasting/snelheidsindex", correct: true },
      { text: "Een productiedatumcode", correct: false },
      { text: "Het maximale gewicht van de bagage", correct: false },
    ],
    explanation: "De DOT-code aan het einde is wél de productiedatum (bijv. 3524 = week 35 van 2024)."
  },
  {
    id: 17, category: "Banden",
    question: "Wat doe je met een reservewiel of thuiskomer?",
    answers: [
      { text: "Alleen tijdelijk gebruiken; niet harder dan 80 km/u met een thuiskomer", correct: true },
      { text: "Onbeperkt op rijden — het is gewoon een band", correct: false },
      { text: "Je hoeft alleen naar de garage als hij lek loopt", correct: false },
    ],
    explanation: "Thuiskomer (smalle reserveband) is voor korte afstand naar de garage — max 80 km/u."
  },

  // ═══════════════════════ MOTORKAP & VLOEISTOFFEN (8 — meest gevraagd) ═══════════════════════
  {
    id: 30, category: "Motorkap & Vloeistoffen",
    question: "Hoe controleer je het motoroliepeil?",
    answers: [
      { text: "Auto op vlakke ondergrond, motor koud/uit; trek de peilstok eruit, veeg af, steek terug en lees af", correct: true },
      { text: "Direct na een snelwegrit terwijl de motor draait", correct: false },
      { text: "Kijk of het lampje op het dashboard brandt", correct: false },
    ],
    explanation: "Peil moet tussen MIN en MAX staan. Onder MIN? Bijvullen — dezelfde olie-type als in het boekje."
  },
  {
    id: 31, category: "Motorkap & Vloeistoffen",
    question: "Welke dop herken je aan een symbool van een ruitenwisser met water?",
    answers: [
      { text: "Het reservoir voor ruitensproeiervloeistof (vaak een blauwe dop)", correct: true },
      { text: "Motorolie", correct: false },
      { text: "Koelvloeistof", correct: false },
    ],
    explanation: "Dop met ruitenwisser-symbool = ruitensproeier. Gebruik winterproef sproeiervloeistof, geen kraanwater (bevriest)."
  },
  {
    id: 32, category: "Motorkap & Vloeistoffen",
    question: "Waar vul je koelvloeistof bij?",
    answers: [
      { text: "In het expansievat (doorzichtig plastic reservoir met MIN/MAX aanduiding)", correct: true },
      { text: "Direct in de radiateur, terwijl de motor heet is", correct: false },
      { text: "Bij de motorolievuldop", correct: false },
    ],
    explanation: "NOOIT openen bij hete motor — kans op brandwonden door stoom. Wachten tot afgekoeld."
  },
  {
    id: 33, category: "Motorkap & Vloeistoffen",
    question: "Waar controleer je de remvloeistof?",
    answers: [
      { text: "Klein reservoirtje aan de bestuurderskant, dicht bij de voorruit — met MIN/MAX streep", correct: true },
      { text: "Onder de auto bij de remschijven", correct: false },
      { text: "In het expansievat samen met de koelvloeistof", correct: false },
    ],
    explanation: "Dalend remvloeistofpeil kan wijzen op slijtage van remblokken of lekkage — direct laten checken."
  },
  {
    id: 34, category: "Motorkap & Vloeistoffen",
    question: "Wat als je motoroliepeil onder MIN staat?",
    answers: [
      { text: "Beetje bij beetje bijvullen (100-200 ml tegelijk) met de juiste olie en opnieuw meten", correct: true },
      { text: "In één keer de hele fles erbij gooien", correct: false },
      { text: "Doorrijden — geeft niks", correct: false },
    ],
    explanation: "Te weinig olie = motorschade. Te veel olie = ook motorschade. Precisie is belangrijk."
  },
  {
    id: 35, category: "Motorkap & Vloeistoffen",
    question: "Hoe herken je de accu onder de motorkap?",
    answers: [
      { text: "Rechthoekige zwarte doos met rode (+) en zwarte (−) polen", correct: true },
      { text: "Ronde metalen dop met olie-symbool", correct: false },
      { text: "Klein doorzichtig blauw reservoir", correct: false },
    ],
    explanation: "Corrosie (wit poeder) op de polen = slecht contact → auto start niet."
  },
  {
    id: 36, category: "Motorkap & Vloeistoffen",
    question: "Wat is het verschil tussen koelvloeistof en antivries?",
    answers: [
      { text: "Antivries wordt gemengd met water tot koelvloeistof — voorkomt bevriezen én oververhitting", correct: true },
      { text: "Antivries is alleen voor 's winters, koelvloeistof alleen voor 's zomers", correct: false },
      { text: "Het is precies hetzelfde met een andere naam", correct: false },
    ],
    explanation: "De juiste mengverhouding staat in het instructieboekje (meestal 50/50)."
  },
  {
    id: 37, category: "Motorkap & Vloeistoffen",
    question: "Wat doe je als het rode oliedruklampje (oliekannetje) tijdens het rijden aangaat?",
    answers: [
      { text: "Zo snel mogelijk veilig stoppen, motor uit, peil controleren en bijvullen of hulp bellen", correct: true },
      { text: "Doorrijden naar huis, komt goed", correct: false },
      { text: "Nog even wachten tot het lampje uit gaat", correct: false },
    ],
    explanation: "Rijden zonder olie = motor totaal-loss binnen enkele minuten."
  },

  // ═══════════════════════ DASHBOARD (4 — foto 1) ═══════════════════════
  {
    id: 60, category: "Dashboard", image: DASH_IMG, highlight: { x: 58.2, y: 26, r: 3 },
    question: "Wat betekent het omcirkelde oranje lampje bovenin het dashboard?",
    answers: [
      { text: "Motorstoringslampje: er is een storing in de motor of het uitlaatgassysteem — laat het zo snel mogelijk controleren", correct: true },
      { text: "Oliedruk te laag — direct de motor uitzetten", correct: false },
      { text: "De motor is aan het voorgloeien, je moet wachten met starten", correct: false },
    ],
    explanation: "Oranje = attentie. Je mag meestal voorzichtig doorrijden naar de garage. Gaat het lampje knipperen? Dan direct veilig stoppen."
  },
  {
    id: 61, category: "Dashboard", image: DASH_IMG, highlight: { x: 77.4, y: 66.5, r: 3 },
    question: "Wat betekent het omcirkelde rode lampje met de P?",
    answers: [
      { text: "De handrem (parkeerrem) is aangetrokken — losmaken voordat je wegrijdt", correct: true },
      { text: "De parkeersensoren staan aan", correct: false },
      { text: "Er is een parkeerplaats in de buurt gevonden", correct: false },
    ],
    explanation: "Blijft dit lampje branden terwijl de handrem los is? Dan kan er een storing in het remsysteem zijn — niet doorrijden."
  },
  {
    id: 62, category: "Dashboard", image: DASH_IMG, highlight: { x: 19.2, y: 62, r: 4.6 },
    question: "Wat geeft de omcirkelde meter links (met het thermometer-symbool) aan?",
    answers: [
      { text: "De temperatuur van de koelvloeistof van de motor — normaal staat hij rond 90 °C", correct: true },
      { text: "De buitentemperatuur", correct: false },
      { text: "Hoeveel motorolie er nog in de motor zit", correct: false },
    ],
    explanation: "Loopt de meter op richting 130 (rood)? Veilig stoppen, motor uit en laten afkoelen. Open het expansievat nooit bij een hete motor."
  },
  {
    id: 63, category: "Dashboard", image: DASH_IMG, highlight: { x: 71.8, y: 55.3, r: 4.8 },
    question: "Wat betekent '230 km' in het omcirkelde vak bij het pompje?",
    answers: [
      { text: "De actieradius: hoeveel kilometer je nog kunt rijden met de brandstof die in de tank zit", correct: true },
      { text: "Hoeveel kilometer je deze rit al hebt gereden", correct: false },
      { text: "Over hoeveel kilometer de auto een onderhoudsbeurt nodig heeft", correct: false },
    ],
    explanation: "De brandstofmeter rechts toont hoe vol de tank is. Het pijltje naast het pompje laat zien aan welke kant de tankklep zit. 'Trip' onderin is de afgelegde afstand."
  },

  // ═══════════════════════ LICHTEN (5 — foto 2) ═══════════════════════
  {
    id: 70, category: "Lichten", image: LIGHT_IMG, highlight: { x: 43.3, y: 39.3, r: 2.6 },
    question: "Wat doet de omcirkelde stand 'AUTO' op de lichtschakelaar?",
    answers: [
      { text: "De verlichting gaat automatisch aan en uit via een lichtsensor (bijv. bij schemer of in een tunnel)", correct: true },
      { text: "Het grootlicht gaat automatisch aan zodra het donker is", correct: false },
      { text: "Alle lichten staan uit, alleen de dagrijverlichting brandt nooit", correct: false },
    ],
    explanation: "Let op: bij mist of regen overdag ziet de sensor het vaak nog als licht. Zet dan zelf het dimlicht aan."
  },
  {
    id: 71, category: "Lichten", image: LIGHT_IMG, highlight: { x: 46.9, y: 31.6, r: 2.4 },
    question: "Welk licht zet je aan met het omcirkelde symbool (twee kleine lampjes)?",
    answers: [
      { text: "Stadslicht (parkeerlicht): zwakke verlichting om gezien te worden, bijv. bij stilstaan in het donker", correct: true },
      { text: "Dimlicht: het normale licht om 's avonds mee te rijden", correct: false },
      { text: "Grootlicht: voor buiten de bebouwde kom", correct: false },
    ],
    explanation: "Met alleen stadslicht mag je niet rijden in het donker — het verlicht de weg niet."
  },
  {
    id: 72, category: "Lichten", image: LIGHT_IMG, highlight: { x: 51.7, y: 28.6, r: 2.4 },
    question: "Welk licht hoort bij het omcirkelde symbool (lamp met schuine strepen naar beneden)?",
    answers: [
      { text: "Dimlicht: het standaard licht bij duisternis, slecht zicht en in tunnels — verblindt tegenliggers niet", correct: true },
      { text: "Grootlicht", correct: false },
      { text: "Mistlamp voor", correct: false },
    ],
    explanation: "De strepen wijzen naar beneden: het licht schijnt op de weg. Grootlicht bedien je met de hendel aan het stuur."
  },
  {
    id: 73, category: "Lichten", image: LIGHT_IMG, highlight: { x: 46.2, y: 67.5, r: 2.6 },
    question: "Welk licht hoort bij het omcirkelde symbool linksonder, en wanneer gebruik je het?",
    answers: [
      { text: "Mistlampen voor: bij mist, sneeuwval of zware regen met slecht zicht", correct: true },
      { text: "Grootlicht: als er geen tegenliggers zijn", correct: false },
      { text: "Mistachterlicht: zodra het regent", correct: false },
    ],
    explanation: "Bij deze auto zet je ze aan door de knop één stand uit te trekken. Het lampje op het dashboard is groen."
  },
  {
    id: 74, category: "Lichten", image: LIGHT_IMG, highlight: { x: 50.2, y: 70.9, r: 2.6 },
    question: "Welk licht hoort bij het omcirkelde symbool rechtsonder, en wanneer mag je het gebruiken?",
    answers: [
      { text: "Mistachterlicht: alleen bij zicht minder dan 50 meter door mist of sneeuwval", correct: true },
      { text: "Achteruitrijlicht: als je achteruit inparkeert", correct: false },
      { text: "Mistachterlicht: altijd als het regent of donker is", correct: false },
    ],
    explanation: "Het mistachterlicht is erg fel en verblindt bestuurders achter je. Bij deze auto: knop twee standen uittrekken. Het dashboardlampje is oranje."
  },
];

export default CBR_QUESTIONS;
